// noinspection JSAnnotator

export default {
	global: 'https://playersupport.nexon.com/hc/en-us',
	th: 'https://th.nexon.com/help/th',
	tw: 'https://tw.nexon.com/help/zh',
	sea: 'https://sea.nexon.com/help/en',
};
